import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TypedMemo } from '../../../common/types';
import { PalettePageMatch } from './usePalettePageMatches';
import { commandPaletteMessages as messages } from './commandPaletteMessages';
import styles from './PalettePageRow.module.scss';

interface PalettePageRowProps {
  match: PalettePageMatch;
  selected: boolean;
  onPick: () => void;
  onHover: () => void;
}

/** A page, a tab or a Settings tab in the palette: "Charts · Artists — Go to" (design 5d). */
const PalettePageRowComponent: React.FC<PalettePageRowProps> = ({ match, selected, onPick, onHover }) => {
  const intl = useIntl();
  return (
    <button
      type="button"
      className={clsx(styles.resultItem, selected && styles.resultItemSelected)}
      onClick={onPick}
      onMouseEnter={onHover}
      data-testid={`palette-page-${match.page.id}`}
    >
      <div className={styles.actionIcon}>
        <FontAwesomeIcon icon={match.page.icon} />
      </div>
      <div className={styles.resultText}>
        <div className={styles.resultTitle}>{match.title}</div>
      </div>
      <span className={styles.resultType}>
        {intl.formatMessage(match.page.kind === 'settings' ? messages.typeSettings : messages.typeGoTo)}
      </span>
    </button>
  );
};

export const PalettePageRow = TypedMemo(PalettePageRowComponent);
